import React from 'react';
import Icon from '../../../components/AppIcon';

const ExecutiveSummaryCard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  benchmark, 
  icon, 
  description,
  trend = [] 
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  const getBenchmarkStatus = () => {
    if (benchmark?.status === 'above') return { color: 'text-success', icon: 'ArrowUp' };
    if (benchmark?.status === 'below') return { color: 'text-error', icon: 'ArrowDown' };
    return { color: 'text-muted-foreground', icon: 'Minus' };
  };

  const benchmarkStatus = getBenchmarkStatus();

  return (
    <div className="bg-card rounded-lg border border-border p-6 card-shadow hover:shadow-lg transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="font-heading-semibold text-sm text-card-foreground">
              {title}
            </h3>
            <p className="text-xs text-muted-foreground font-caption">
              {description}
            </p>
          </div>
        </div>
        
        {trend?.length > 0 && (
          <div className="w-16 h-8">
            <svg viewBox="0 0 64 32" className="w-full h-full">
              <polyline
                points={trend?.map((point, index) => 
                  `${(index / (trend?.length - 1)) * 64},${32 - (point / Math.max(...trend)) * 32}`
                )?.join(' ')}
                fill="none"
                stroke={changeType === 'positive' ? '#2E7D32' : changeType === 'negative' ? '#D32F2F' : '#6B4E3D'}
                strokeWidth="2"
                className="opacity-60"
              />
            </svg>
          </div>
        )}
      </div>
      <div className="space-y-3">
        <div className="flex items-baseline space-x-2">
          <span className="text-2xl font-heading-bold text-card-foreground">
            {value}
          </span>
          {change && (
            <div className={`flex items-center space-x-1 ${getChangeColor()}`}>
              <Icon name={getChangeIcon()} size={16} />
              <span className="text-sm font-body-medium">
                {change}
              </span>
            </div>
          )}
        </div>

        {benchmark && (
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">
              vs. Benchmark: {benchmark?.value}
            </span>
            <div className={`flex items-center space-x-1 ${benchmarkStatus?.color}`}>
              <Icon name={benchmarkStatus?.icon} size={12} />
              <span className="font-body-medium">
                {benchmark?.difference}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExecutiveSummaryCard;